import React, { Component } from "react";
import {
  Grid,
  Header,
  Button,
  Form,
  Input,
  Transition
} from "semantic-ui-react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.min.css";
import { connect } from "react-redux";
import { setForm } from "../../../store/actions/form";
import moment from "moment";
import { googleTracking } from '../../../util';
import { AVAILABLE_PREWIRED } from "../../../data/status";

class Step4 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      animation: props.animation,
      date: null
    };
    this.transitionBack = this.transitionBack.bind(this);
    this.transitionNext = this.transitionNext.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.save = this.save.bind(this);
    this.onDatepickerRef = this.onDatepickerRef.bind(this);
    this.isWeekday = this.isWeekday.bind(this);
  }

  componentDidMount() {
    googleTracking({ 'event': 'virtualPageview', 'pageview': '/prewired/step4/choose-activation-data' })
    const { activationDate } = this.props;
    this.setState({
      visible: true,
      date: activationDate ? moment(activationDate).toDate() : null
    });
  }

  onDatepickerRef(el) {
    if (el && el.input) {
      el.input.inputRef.readOnly = true;
    }
  }

  transitionBack() {
    const { changeStep } = this.props;

    this.setState({
      animation: "fade left",
      visible: !this.state.visible
    });
    setTimeout(() => {
      changeStep(2, "fade right");
    }, 400);
  }

  transitionNext() {
    const { changeStep, status } = this.props;

    this.setState({
      animation: "fade right",
      visible: false
    });

    if (status === AVAILABLE_PREWIRED) {
      setTimeout(() => {
        changeStep(3, "fade left");
      }, 400);
    }
    else {
      setTimeout(() => {
        changeStep(5, "fade left");
      }, 400);
    }
  }

  handleChange(e) {
    this.setState({
      date: e
    });
    this.props.setActivationDate({
      activationDate: e ? moment(e).format("YYYY-MM-DD") : null,
      activationDateUser: e ? moment(e).format("MMMM DD, YYYY") : null
    });
  }

  isWeekday(date) {
    const day = date.getDay();
    return day !== 0 && day !== 6;
  };
  save() {
    this.transitionNext();
  }

  render() {
    const { visible, animation } = this.state;

    return (
      <div>
        <div className="back--icon" onClick={this.transitionBack} />
        <Transition visible={visible} duration={500} animation={animation}>
          <div>
            <Header className="title__main" as="h1" textAlign="center">
              Choose Activation Date
            </Header>
            <Header.Subheader className="text-black">
              When would you like your service to start?
            </Header.Subheader>

            <Grid className="form__signup choose-activation-code width__xs">
              <Grid.Row className="py-0">
                <Grid.Column className="px-0">
                  <Form>
                    <Form.Field>
                      <DatePicker
                        placeholderText="Click to select a date"
                        onChange={this.handleChange}
                        selected={this.state.date}
                        dateFormat="MMMM dd, yyyy"
                        minDate={moment().toDate()}
                        ref={el => this.onDatepickerRef(el)}
                        customInput={
                          <Input
                            labelPosition="right"
                            label={<div className="label__text">Date</div>}
                          />
                        }
                      />
                    </Form.Field>
                    <div className="bolt-message">
                      <i aria-hidden="true" className="green bolt icon " />
                      <div className="text-message text-grey f-size--12 text-grey5">
                        Your unit is prewired and ready for instant activation.
                        No technician required!
                      </div>
                    </div>
                    <Button
                      size="medium"
                      className="btn--full"
                      onClick={this.save}
                      disabled={this.props.activationDate === null}
                    >
                      Next
                    </Button>
                  </Form>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
        </Transition>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setActivationDate: data => dispatch(setForm(data))
  };
};

const mapStateToProps = state => {
  return {
    activationDate: state.form.activationDate,
    status: state.connection.status,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Step4);



// WEBPACK FOOTER //
// ./src/components/check-availability/service-available/Step4.js